import { PRODUCT_FEATURES } from "core/consts";
import { Careseeker } from "core/types";
import { getProductFeatureActive } from ".";

export function getIsDtaActive({
  careseeker,
}: {
  careseeker: Careseeker | undefined;
}) {
  return getProductFeatureActive(
    careseeker?.product_features,
    PRODUCT_FEATURES.DTA,
  );
}
